//import firebase from 'firebase/app';
//import 'firebase/functions';
import parentCartService from '@/app-template/lib/services/CartService';

export default {
  ...parentCartService,
}